import { useQueryGetBookingById } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { FlectoLanguages } from '@flecto/translations/src/types/FlectoLanguages'
import { type ParameterID } from '@flecto/types'

export function useBookingDocumentTranslation({
  bookingId,
}: {
  bookingId?: ParameterID
}) {
  const { data: booking, isSuccess } = useQueryGetBookingById({ bookingId })

  const language = booking?.customer?.locale ?? FlectoLanguages.DEFAULT

  return {
    isSuccess,
    useTranslation: () =>
      useTranslation('saas', {
        keyPrefix: 'booking_documents',
        lng: language,
      }),
  }
}
